import React from 'react'
import { MatchClientModel } from '@sport1/types/sportData'
import dayjs from 'dayjs'
import Font from '@sport1/news-styleguide/Font'
import CardHeadline from '@sport1/news-styleguide/CardHeadline'
import { getTeamName } from '@/components/SportEvent/utils'
import { sport1Regular } from '@/helpers/fonts'

type LivetickerHeadlineProps = {
    match: MatchClientModel
}

const getMatchDate = (scheduledStartTime?: string): string => {
    if (!scheduledStartTime) return ''
    const dayJsStartTime = dayjs(scheduledStartTime)
    return `, ${dayJsStartTime.format('DD.MM.YYYY')}, ${dayJsStartTime.format('HH:mm')} Uhr`
}

export const getLivetickerHeaderTeams = (match: MatchClientModel): string =>
    match.homeTeam && match.awayTeam
        ? `${getTeamName(match.homeTeam)} - ${getTeamName(match.awayTeam)}`
        : ''

const LivetickerHeadline = ({ match }: LivetickerHeadlineProps) => {
    return (
        <>
            <CardHeadline
                text={`${getLivetickerHeaderTeams(match)} Liveticker ${
                    match.competition?.name || ''
                }`}
                cardHeadlineType={['cardHeadlineS', 'cardHeadlineM', 'cardHeadlineM']}
            />
            <Font
                fontVariant="Title-S"
                fontFamilyVariant="Sport1-Regular"
                numberOfLines={1}
                nextFontFamilyVariant={sport1Regular.style.fontFamily}
            >{`${match.roundTitle}${getMatchDate(match.scheduledStartTime)}`}</Font>
        </>
    )
}

export default LivetickerHeadline
